import { httpCreate } from './http';

const http = httpCreate('/srv/blessActivity');

const https = httpCreate('/excel/live/bless');

export const blessActivity = {
	// 添加福袋
	addedBlessingBag(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	postFrom(activityId, smsCode, data) {
		return http.post(`/${activityId}?smsCode=${smsCode}`, data);
	},
	// 修改福袋
	editBlessingBag(Id, data) {
		return http.put(`/${Id}`, data);
	},
	emitFrom(Id, smsCode, data) {
		return http.put(`/${Id}?smsCode=${smsCode}`, data);
	},
	// 获取福袋列表
	getBlessingBagList(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},
	// 删除福袋
	removeBlessingBag(blessId) {
		return http.delete(`/${blessId}`);
	},
	// 获取福袋必中奖人员名单
	getBlessingLotteryUser(blessId) {
		return http.get(`/${blessId}/mustWinUsers`);
	},
	// 添加中奖人员
	changeCanWin(blessId, data) {
		return http.post(`/changeCanWin/${blessId}`, data);
	},
	blackList(blessId, params) {
		return http.get(`/blackList/${blessId}`, { params });
	},
	addBlack(blessId, data) {
		return http.post(`/addBlack/${blessId}`, { mobPhone: data });
	},
	batch(blessId, phones) {
		return http.delete(`/batch/${blessId}`, { data: phones });
	},
	virtually(blessId, num) {
		return http.post(`/virtually/${blessId}/${num}`);
	},
	upload(lotteryId, file) {
		return http.post(`/importBlack/${lotteryId}`, file);
	},
	getVirtually(blessId) {
		return http.get(`/virtually/${blessId}`);
	},
	getParticipateList(activityId, params) {
		return http.get(`/${activityId}/joins`, { params });
	},
	getLotteryList(activityId, params) {
		return http.get(`/${activityId}/winList`, { params });
	},
	getWriteOff(id, data) {
		return http.put(`/operator/${id}`, data);
	},
	getWinListCount(activityId, params) {
		return http.get(`/${activityId}/winListCount`, { params });
	},

	// addblessActivi(activityId, blessId) {
	//   return http.post(`join/${activityId}/${blessId}`)
	// }
};
